import { render } from "./tipsList.vue?vue&type=template&id=51cf0f36&scoped=true"
import script from "./tipsList.vue?vue&type=script&lang=js"
export * from "./tipsList.vue?vue&type=script&lang=js"

import "./tipsList.vue?vue&type=style&index=0&id=51cf0f36&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-51cf0f36"

export default script